export default __webpack_public_path__ + "static/media/TV_Cancao_Nova.5c4b951c.png";